import { Box, Card, CardContent, Typography, Divider } from "@mui/material";
import { benefits } from "./premiumData";

function BenefitsListe() {
    return (
        <Card sx={{
            mb: 3, borderRadius: "16px",
            background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
            border: "1px solid rgba(212, 175, 55, 0.15)"
        }}>
            <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                <Typography variant="caption" sx={{ color: '#b38728', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', mb: 2 }}>
                    Vorteile im Überblick
                </Typography>

                {benefits.map((b, i) => (
                    <Box key={i}>
                        <Box display="flex" alignItems="flex-start" gap={1.5} py={1.5}>
                            <Box sx={{
                                width: 38, height: 38, borderRadius: '10px',
                                bgcolor: b.bg, color: b.color,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                flexShrink: 0, '& svg': { fontSize: '1.2rem' }
                            }}>
                                {b.icon}
                            </Box>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#e2e8f0' }}>
                                    {b.title}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#64748b', lineHeight: 1.5, display: 'block' }}>
                                    {b.desc}
                                </Typography>
                            </Box>
                        </Box>
                        {i < benefits.length - 1 && (
                            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.08)' }} />
                        )}
                    </Box>
                ))}
            </CardContent>
        </Card>
    );
}

export default BenefitsListe;
